export default __webpack_public_path__ + "7e873d3833eb108a0758be45cd29e907.ttf";